import ErrorBoundary from './components/Shared/ErrorBoundary'
import history from './history'
import { Component } from 'react/cjs/react.production.min'
import { Navigate, Outlet, Route, Routes, unstable_HistoryRouter as HistoryRouter, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from './components/Default/Auth'
import OAuth from './components/Default/Auth/OAuth'
import PropertyListPage from './components/Default/Pages/PropertyList'
import ContentMonitorPage from './components/Default/Pages/ContentMonitor'
import OAuthLandingPage from './components/Default/Pages/OAuthLandingPage'
import PropertyPage from './components/Default/Pages/Property'
import ErrorPage from './components/Default/Pages/ErrorPage'
import { errors as ErrorPageConstants } from './components/Default/Pages/ErrorPage/constants'
import LegacyHotelierPropertyJumpPage from './components/Default/Pages/LegacyHotelierPropertyJumpPage'
import ThirdPartyAuthLandingPage from './components/Default/Pages/ThirdPartyAuthLandingPage'
import HubSpotChat from './components/Shared/HubSpot/chat'
import ProductFruitsContainer from './components/Shared/ProductFruitsContainer'
import { ToastProvider } from './components/Shared/Toast'

class AppRouter extends Component {
  render () {
    return (
      <HistoryRouter history={history}>
        <ErrorBoundary>
          <ToastProvider>
            <Routes>
              <Route element={<RequireAuth isAuthenticated={this.props.isAuthenticated}/>}>
                <Route path="/hotelier/:hash" element={<LegacyHotelierPropertyJumpPage/>}/>
                <Route path="/property/:id/:subPage?" element={<PropertyPage/>}/>
                <Route path="/properties-list" element={<PropertyListPage/>}/>
                <Route path="/content-monitor" element={<ContentMonitorPage/>}/>
              </Route>
              <Route path="/oauth/giata" element={<OAuthLandingPage/>}/>
              <Route path="/auth/suppliers/:supplierId/codes/:code" element={<ThirdPartyAuthLandingPage/>}/>

              <Route path="/errors/not-authenticated" element={
                <ErrorPage error={ErrorPageConstants.notAuthenticated}/>
              }/>
              <Route path="/errors/not-authorized" element={
                <ErrorPage error={ErrorPageConstants.notAuthorized}/>
              }/>
              <Route path="/errors/confirmation-link-expired" element={
                <ErrorPage error={ErrorPageConstants.confirmationLinkExpired}/>
              }/>
              <Route path="/errors/confirmation-link-invalid" element={
                <ErrorPage error={ErrorPageConstants.confirmationLinkInvalid}/>
              }/>
              <Route path="/errors/property-not-found" element={
                <ErrorPage error={ErrorPageConstants.propertyNotFound}/>
              }/>
              <Route path="/errors/unknown" element={
                <ErrorPage error={ErrorPageConstants.unknown}/>
              }/>
              <Route path="*" element={<Navigate replace to="/properties-list"/>}/>
            </Routes>
            <HubSpotChat portalId={'5405124'}/>
            <ProductFruitsContainer workspaceCode={'wJq6q7G1LVVFpbt9'}/>
          </ToastProvider>
        </ErrorBoundary>
      </HistoryRouter>
    )
  }
}

function RequireAuth ({ isAuthenticated }) {
  let location = useLocation()

  if (!isAuthenticated) {
    return <OAuth from={location}/>
  }
  return <Auth><Outlet/></Auth>
}

const mapStateToProps = state => ({
  isAuthenticated: !!state.user.loggedIn
})
export default connect(mapStateToProps, {})(AppRouter)
